import { Margin, Padding } from './Offset';

export { Margin, Padding };


// WEBPACK FOOTER //
// ./src/baseComponents/directives/Offset/index.js